// PrescriptionPreviewPage.js
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useHttpClient } from '../../shared/hooks/http-hook';
import PrescriptionPreview from './PrescriptionPreview';
import { AuthContext } from '../../shared/Context/auth-context';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { BACKEND_URL } from '../../shared/util/backend-url';

const PrescriptionPreviewPage = () => {
  const { prescriptionId } = useParams();
  const { sendRequest, isLoading } = useHttpClient();
  const [prescriptionData, setPrescriptionData] = useState(null);
  const auth = useContext(AuthContext);

  useEffect(() => {
    const fetchPrescription = async () => {
      try {
        const response = await sendRequest(
          `${BACKEND_URL}/api/prescriptions/${prescriptionId}`,
          'GET',
          null,
          {
            'Authorization': 'Bearer ' + auth.token
          }
        );
        setPrescriptionData(response.prescription);
      } catch (err) {
        console.error('Failed to load prescription', err);
      }
    };
    fetchPrescription();
  }, [prescriptionId, sendRequest, auth.token]);

  if (isLoading || !prescriptionData) return <LoadingSpinner asOverlay />;

  return (
    <PrescriptionPreview
      prescriptionData={{
        doctorName: prescriptionData.doctor.name,
        specialization: prescriptionData.doctor.specialization || "MBBS, MD",
        location: prescriptionData.doctor.location || "Clinic Address",
        phone: prescriptionData.doctor.phoneNumber || "",
            date: new Date(prescriptionData.createdAt).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }),
        patientName: prescriptionData.patient.name,
        age: prescriptionData.patient.age,
        sex: prescriptionData.patient.gender,
        diagnosis: prescriptionData.condition,
        vitals: `Height: ${prescriptionData.patient.height} cm, Weight: ${prescriptionData.patient.weight} kg, Blood Group: ${prescriptionData.patient.bloodGroup}`,
        remarks: prescriptionData.remarks,
        medications: prescriptionData.medication,
        signature: prescriptionData.doctor.signature,
        memberCode: `MCI ${prescriptionData.doctor.membercode || 'XXXXXX'}`
      }}
      fullData={prescriptionData}
    />
  );
};

export default PrescriptionPreviewPage;